/* eslint-disable no-prototype-builtins */
// @flow

import type { Action } from './types';
import types from './types';

type AppState = {
  projects: Array<>,
  isDark: boolean,
};

const INITIAL_STATE = {
  projects: [],
  isPending: false,
  isDarkTheme: null,
};

function appReducer(state: AppState = INITIAL_STATE, action: Action): AppState {
  switch (action.type) {
    case types.GET_PROJECTS_REQUEST: {
      return {
        ...state,
        isPending: true,
      };
    }
    case types.GET_PROJECTS_SUCCESS: {
      return {
        ...state,
        isPending: false,
        projects: action.payload,
      };
    }
    case types.GET_PROJECTS_ERROR: {
      return {
        ...state,
        isPending: false,
      };
    }
    case types.CHECK_IS_DARK: {
      return {
        ...state,
        isDarkTheme: action.payload,
      };
    }
    default:
      return state;
  }
}

export default appReducer;



// WEBPACK FOOTER //
// ./src/view/duck/reducers.js